var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoffeesOn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 56,
    viewBox: "0 0 55 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55.8533,
    rx: 27.5,
    fill: "#F4DBD7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.8094 26.0993V35.236C34.8094 38.2636 32.355 40.718 29.3274 40.718H20.1907C17.1631 40.718 14.7087 38.2636 14.7087 35.236V26.0993C14.7087 25.0901 15.5269 24.272 16.5361 24.272H32.9821C33.9913 24.272 34.8094 25.0901 34.8094 26.0993ZM34.8094 26.0993H38.4641C39.4733 26.0993 40.2914 26.9174 40.2914 27.9266V31.5813C40.2914 32.5905 39.4733 33.4086 38.4641 33.4086H34.8094M22.0181 21.531V17.8763M27.5001 21.531V14.2216",
    stroke: "black",
    strokeWidth: 1.82733
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffeesOn);
export default __webpack_public_path__ + "static/media/coffees_on.f9edf853fbc1ebcf9f5bbe92fd33dc31.svg";
export { ForwardRef as ReactComponent };